import React from 'react'
import { Grid, Button  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';

const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

const validate = values => {
    const error  = {}

    if (/^\d*(\.\d{2})$/.test(values.customamount) === false) {
        error.customamount = "El campo Monto a pagar solo permite valores con 2 decimales. Ejemplo: 30.00"
    }
    
    return error
}

const ServiceSwicthCustomAmountForm = props => {

    const classes = useStyles();

    const { titleLabelReference, onCancelAction, handleSubmit, invalid } = props;

    return (
        <div>
            <form className={classes.form} onSubmit={ handleSubmit }>
                <Grid container spacing={3}>
        
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        
                        <Field
                            name="institution"
                            id="institution"
                            disabled = { true }
                            component={ RenderTextFieldRedux }
                            label= {"Convenio"}
                            fullWidth
                        />

                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        
                        <Field
                            name="reference"
                            id="reference"
                            disabled = { true }
                            component={ RenderTextFieldRedux }
                            label= {titleLabelReference}
                            fullWidth
                        />
                        
                    </Grid>
                    
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                    
                        <Field
                            name="customamount"
                            id="customamount"
                            autoFocus = { true }
                            component={ RenderTextFieldRedux }
                            label= {"Monto a Pagar"}
                            fullWidth
                        />
                        
                    </Grid>
                    
                    
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            fullWidth
                            color="primary"
                            disabled={ invalid }
                            >
                            Consultar
                        </Button>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" className={classes.button} onClick = { () => onCancelAction() }>
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

const ServiceSwicthCustomAmountFormReduxForm = reduxForm(
    {
        form: 'ServiceSwicthCustomAmountForm',
        validate
    }
)(ServiceSwicthCustomAmountForm)
export default ServiceSwicthCustomAmountFormReduxForm
